import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { ErrorHandlerDirective } from './directives/error-handler.directive';
import { authInterceptorProviders } from './auth.interceptor';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonRestService } from './services/CommonRest.service';
import { BusinessCommonService } from './services/business-common.service';
import { HttpInterceptorService } from './core/interceptor/httpinterceptor-service';
import { AppCookieService, LoaderComponent, NotificationsComponent, TranslationService } from '@ace/ace';
// import { UserLoggingComponent } from './layouts/user-logging/user-logging.component';
import { CookieService } from 'ngx-cookie-service';
import { ACE_MAIN_NAV_PAGES, APP_ENVIRONMENT } from '@ace/ace';
import { environment } from '../environments/environments';
import mainPages from './config/main-pages.json';

export function HttpLoaderFactory(http: HttpClient)
{
  const langPath = "./assets/i18n/";
  return new TranslateHttpLoader(http, langPath, '.json');
}

export function initializeTranslations(translationService: TranslationService) {
  return () => {
    const savedLanguage = localStorage.getItem('appLang') || 'en';
    return translationService.init(savedLanguage);
  };
}
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    LoaderComponent,
    NotificationsComponent,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      countDuplicates: false,
      maxOpened: 1,
      autoDismiss: true,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    TranslateModule,
  ],
  providers: [
    authInterceptorProviders,
    CommonRestService,
    BusinessCommonService,
    AppCookieService,
    ErrorHandlerDirective,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTranslations,
      deps: [TranslationService],
      multi: true,
    },
    { provide: APP_ENVIRONMENT, useValue: environment },
    { provide: ACE_MAIN_NAV_PAGES, useValue: mainPages },
    DatePipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }


